export default __webpack_public_path__ + "e505e00.png";